export const FeatureFlag = {
  crossSellPaymentPage: 'crossSellPaymentPage',
  ren1520_compliancewelcome_newdesign: 'ren1520_compliancewelcome_newdesign',
  ren1487_coverage_details_newdesign: 'ren1487_coverage_details_newdesign',
  utmParamsFeatureFlag: 'ren1924_utm_params_feature_flag',
  ren1402_start_application_new_flow: 'ren1402_start_application_new_flow',
  ren3614NewPaymentWidget: 'ren3614_new_payment_widget'
} as const;

export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];
